<template>
	<div>
		<div class="container">
			<div class="row">
				<div class="col-12">
					<svg width="200" class="svg-logo" viewBox="0 0 238.1 39.5" enable-background="new 0 0 238.1 39.5" xml:space="preserve">
<g>
<g>
<path fill="#49a5a9" d="M32.4,15.5v20.7c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5V15.5c0-6.7-3.7-10.6-10.3-10.6 C10,4.8,5,9.3,5,18.8v17.3c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5L0,3.4C0,2,1.1,0.9,2.5,0.9h0C3.9,0.9,5,2,5,3.4v1.2 C5,5.3,5.8,5.5,6.2,5C9,1.7,12.8,0,17.6,0C26.8,0,32.4,6,32.4,15.5z"/>
</g>
<g>
<path fill="#49a5a9" d="M73,6c3.5,3.9,5.2,8.6,5.2,13.9c0,0,0,0,0,0c0,1.3-1.1,2.3-2.4,2.3l-27.7,0c-1.7,0-2.9,1.6-2.4,3.2 c2,5.7,7.4,9.2,14.2,9.2c4.8,0,8.7-1.8,11-4.7c0.8-0.9,2.1-1.1,3.1-0.5v0c1.3,0.8,1.6,2.6,0.6,3.8c-3.5,3.9-8.7,6.3-14.8,6.3 c-6,0-10.8-1.9-14.5-5.6c-3.7-3.7-5.6-8.4-5.6-14.2c0-5.7,1.8-10.3,5.5-14.1C49,1.9,53.7,0,59.5,0C65.1,0,69.6,2,73,6z M48.1,17.4 H70c1.7,0,2.9-1.6,2.4-3.2c-0.8-2.5-2.1-4.5-3.9-6.1c-2.6-2.2-5.6-3.3-9-3.3c-6.6,0-11.8,3.7-13.8,9.3 C45.1,15.7,46.4,17.4,48.1,17.4z"/>
</g>
<g>
<path fill="#49a5a9" d="M113.4,0.9L113.4,0.9c1.7,0,2.9,1.8,2.3,3.4l-12.9,31.5c-0.7,1.7-2.3,2.8-4.2,2.8h0 c-1.8,0-3.5-1.1-4.2-2.8L81.4,4.3c-0.7-1.6,0.5-3.4,2.3-3.4h0c1,0,1.9,0.6,2.3,1.5l10.3,25.4c0.8,2,3.7,2,4.5,0l10.3-25.4 C111.5,1.5,112.4,0.9,113.4,0.9z"/>
</g>
<g>
<path fill="#49a5a9" d="M151.8,0.9L151.8,0.9c1.7,0,2.9,1.8,2.3,3.4l-12.9,31.5c-0.7,1.7-2.3,2.8-4.2,2.8l0,0 c-1.8,0-3.5-1.1-4.2-2.8L119.9,4.3c-0.7-1.6,0.5-3.4,2.3-3.4h0c1,0,1.9,0.6,2.3,1.5l10.3,25.4c0.8,2,3.7,2,4.5,0l10.3-25.4 C149.9,1.5,150.8,0.9,151.8,0.9z"/>
</g>
<g>
<path fill="#49a5a9" d="M177.5,39.5c-5.5,0-10.3-1.9-14.1-5.7c-3.8-3.8-5.7-8.5-5.7-14.1c0-5.6,1.9-10.3,5.7-14 C167.3,1.9,172,0,177.5,0c5.5,0,10.2,1.9,14,5.7c3.8,3.8,5.8,8.4,5.8,14c0,5.6-2,10.3-5.8,14.1C187.7,37.6,183,39.5,177.5,39.5z M177.5,34.7c4.1,0,7.7-1.4,10.6-4.3c2.9-2.9,4.3-6.5,4.3-10.6c0-4.1-1.4-7.7-4.3-10.6c-2.9-2.9-6.4-4.4-10.6-4.4 c-4.1,0-7.7,1.4-10.6,4.4c-2.9,2.9-4.3,6.4-4.3,10.6c0,4.1,1.4,7.7,4.3,10.6C169.8,33.2,173.4,34.7,177.5,34.7z"/>
</g>
<g>
<path fill="#49a5a9" d="M238.1,15.5v20.7c0,1.4-1.1,2.5-2.5,2.5h0c-1.4,0-2.5-1.1-2.5-2.5V15.5c0-6.7-3.7-10.6-10.3-10.6 c-7.2,0-12.2,4.4-12.2,14v17.3c0,1.4-1.1,2.5-2.5,2.5l0,0c-1.4,0-2.5-1.1-2.5-2.5V3.4c0-1.4,1.1-2.5,2.5-2.5l0,0 c1.4,0,2.5,1.1,2.5,2.5v1.2c0,0.7,0.8,0.9,1.2,0.4c2.7-3.4,6.6-5,11.4-5C232.4,0,238.1,6,238.1,15.5z"/>
</g>
</g>
</svg>
				</div>
			</div>
		</div><!--container-->
		<main id="login-section" class="login-section full-height thumb-container d-flex align-items-start justify-content-center">
		<div class="container">

		    <div class="row justify-content-center">
			    <div class="col-12 col-sm-8 col-lg-6 col-xl-4">
		            <div class="panel-heading">Login</div>
					<form id="app" @submit.prevent="login"  action="/panel" method="post">

						<p class="text-danger" v-show="error_login" >{{ message_error_login }}</p>
		                <div class="input-content input-content-email input-content-icon">
		                    <input id="input-email" placeholder="Email" type="text" name="email"  v-validate="'required'" v-model="login_data.email" :style="{'border-bottom' : '0px'}" />
		                    <label for="input-email"></label>
							<span class="input-error-msg">{{ errors.first('email') }}</span>
		                </div>

		                 <div class="input-content input-content-password input-content-icon">
		                     <input id="input-password" placeholder="Password" type="password" v-validate="'required|min:6'"   name="password" value="holicaracoli" v-model="login_data.password" :style="{'border-bottom' : '0px'}" />
		                    <label for="input-password"></label>
							<span class="input-error-msg">{{ errors.first('password') }}</span>
		                </div>

		                <label>

		                    	<input type="checkbox" id="checkbox-remember" name="remember">
		                    	<label for="checkbox-remember">Remember Me</label>

		                </label>
		                <div class="row justify-content-between">
		                    <div class="col">
		                    	<router-link tag="a" class="reset-pass-link underline"
		                    		:to="{ name : 'forgot-password' }">
		                    		Forgot Your Password?
		                    	</router-link>

		                    </div>
		                    <div class="col text-right">
		                        <button type="submit" class="button w-100">
		                            Login
		                        </button>
		                    </div>
		                </div>
					</form>
		        </div>
		    </div>
		</div>
    </main>

	</div>

    <!--
    <div>
		<label class="form-label">Email address</label>
	            <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email"
	            		v-model="login_data.email">

	    <label class="form-label">
	              Password
	    </label>
	    <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="login_data.password">

	    <button type="submit" class="btn btn-success btn-block" @click.prevent="login()">Sign in</button>

	    <p class="text-danger" v-show="error_login" >{{ message_error_login }}</p>

	    <p>Login users (offline, only test)</p>
	    <table class="table">
	        <thead>
	          <th>Role</th>
	          <th>Username/Email</th>
	          <th>Pass</th>
	        </thead>
	        <tbody>
	          <tr>
	            <td>Superadmin</td>
	            <td>admin</td>
	            <td>admin</td>
	          </tr>
	          <tr>
	            <td>Organization (LHCSA)</td>
	            <td>organization</td>
	            <td>organization</td>
	          </tr>
	          <tr>
	            <td>SME</td>
	            <td>sme</td>
	            <td>sme</td>
	          </tr>
	        </tbody>
	    </table>
	</div>
	-->
</template>



<script>
export default {
  data: function() {
    return {
      login_data: {
        email: "",
        password: ""
      },
      error_login: false,
      message_error_login: ""
    };
  },
  computed:{
    role : function(){
        return this.$store.getters.getRole;
    },
    meta_actions : function(){
      return localStorage.getItem('meta_actions')
    }
  },
  created: function(){
    console.log("LOGIN CREATED");
    var current_url = window.location.href;

    if (current_url.includes("sso") == false) {
      this.checkToken();
    }
  },
  methods: {
    checkToken: function(){
      this.$store.dispatch('checkAccessToken').then((res) => {
       console.log(res)
        this.redirectAuthenticatedUser(this.role)
      }).catch((error) => {
        this.setServerError(error);
      })
    },
    login: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.error_login = false;
          this.message_error_login = "";

          //dispatch the login and catch the response with the promise declared in vuex Authmodule
          this.$store
            .dispatch("login", {
              login_data: this.login_data
            })
            .then(res => {
              console.log(res);

              if (res.data.user.view == "organization") {
                this.$router.push({ name: "organization.providers.index" });
              } else if (res.data.user.view == "csm") {
                this.$router.push({ name: "csm.providers.index" });
              } else if (res.data.user.view == null) {
                this.$store.dispatch("logout", { router: this.$router });
              } else if (res.data.user.view == "sme") {
                this.$router.push({
                  name: "sme.dashboard",
                  params: { section: "Programs" }
                });
              } else {
                this.$router.push({ name: res.data.user.view + ".dashboard" });
                this.error_login = true;
              }
            })
            .catch(error => {
              this.setServerError(error)
              this.error_login = true;
              this.message_error_login = error.data.message;
            });
        }
      });
    },
    setServerError(error){
      //check error if necessary redirect set server error
      if (!error || (error && error.status && error.status == 500)) {
        let router_status = {
          name:  this.$route.name,
          params: this.$route.params,
          query:  this.$route.query,
        }
        this.$store.commit("setRouterStatus", router_status);
        this.$store.commit("setPageLoading", false);
        this.$store.commit("setServerError", true);
        // this.$router.push({ name: "maintanence" });
        return;
      }

    },
    redirectAuthenticatedUser(role){
      console.log(role, "here???")
        switch(role){
          case 'admin' :
            this.$router.push({ name : 'admin.dashboard' }); break;
          case 'organization' :
            if(this.meta_actions.includes('list_provider')){
               this.$router.push({ name : 'organization.providers.index' }); break;
            }else{
              this.$router.push({ name : 'organization.organizations.index' }); break;
            }
          case 'sme' :
            this.$router.push({ name : 'sme.dashboard' }); break;
          case 'csm' :
            if(this.meta_actions.includes('list_provider')){
             this.$router.push({ name : 'csm.providers.index' }); break;
            }else{
             this.$router.push({ name : 'csm.programs.index' }); break;
            }
        }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/LoginComponent.vue